import { render, staticRenderFns } from "./BaseDate.vue?vue&type=template&id=420f6096"
import script from "./BaseDate.vue?vue&type=script&lang=js"
export * from "./BaseDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports